import { useEffect } from "react";

const DEFAULTS = {
    siteName: "Make Rizk",
    baseTitle: "Make Rizk — Streetwear Maroc",
    defaultDescription:
        "Make Rizk — Streetwear urbain marocain. T-shirts et casquettes en édition limitée. Livraison partout au Maroc. Paiement à la livraison.",
    defaultImage:
        "https://images.unsplash.com/photo-1651050089406-1df57d4a627d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

function upsertMeta(selector, attr, value, content) {
    if (!content) return;
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export default function Seo({
    title,
    description = DEFAULTS.defaultDescription,
    image = DEFAULTS.defaultImage,
    type = "website",
    url,
    price,
    currency = "MAD",
}) {
    useEffect(() => {
        const fullTitle = title ? `${title} · ${DEFAULTS.siteName}` : DEFAULTS.baseTitle;
        document.title = fullTitle;

        upsertMeta('meta[name="description"]', "name", "description", description);

        // Open Graph
        upsertMeta('meta[property="og:site_name"]', "property", "og:site_name", DEFAULTS.siteName);
        upsertMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
        upsertMeta('meta[property="og:description"]', "property", "og:description", description);
        upsertMeta('meta[property="og:image"]', "property", "og:image", image);
        upsertMeta('meta[property="og:type"]', "property", "og:type", type);
        upsertMeta(
            'meta[property="og:url"]',
            "property",
            "og:url",
            url || window.location.href
        );
        upsertMeta('meta[property="og:locale"]', "property", "og:locale", "fr_MA");

        // Twitter
        upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
        upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
        upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
        upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

        // Product-specific tags
        if (type === "product" && price != null) {
            upsertMeta(
                'meta[property="product:price:amount"]',
                "property",
                "product:price:amount",
                String(price)
            );
            upsertMeta(
                'meta[property="product:price:currency"]',
                "property",
                "product:price:currency",
                currency
            );
        }

        // Canonical
        upsertLink("canonical", url || window.location.href);
    }, [title, description, image, type, url, price, currency]);

    return null;
}
